import moment from "moment";
import React from "react";
import { orderIsCancelled } from "../Helpers/OderUtils";
import "../Styles/_OrderCancelledInformation.css";
import { Confirmed } from "./_Icon";

const OrderCancelledInformation = ({ currentLanguage, order }) => {
    if (!orderIsCancelled(order)) {
        return false;
    }

    return (
        <div className="cancelled-container">
            <div className="cancelled-container-label">
                <Confirmed fill="#BF0000" />
                <p>
                    {`${currentLanguage.ORDER_PAGE.CANCELLED_SECTION.CANCELLED_MESSAGE} `}
                    {moment(order.cancelled_at).format("LL")}
                </p>
            </div>
        </div>
    );
};

export default OrderCancelledInformation;
